<script setup lang="js">
import useModal from '@/stores/modal.store';
const { closeModal } = useModal();
function close() {
  closeModal();
}
const props = defineProps({
  hideButtons: {
    type: Boolean,
    default: false
  },
  disableButtons: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
  <div class="transparent-bg d-flex justify-content-center align-items-center">
    <div class="row modal-center justify-content-between">
      <div class="modal-top">
        <h1 class="modal-title pb-2"><slot name="title"></slot></h1>
        <img
          src="@/assets/img/close-img.svg"
          alt="close-img.svg"
          @click="close"
          class="modal-close-ico"
        />
        <slot name="body"></slot>
      </div>
      <div class="d-flex justify-content-between align-items-end mt-2" v-if="!hideButtons">
        <button class="btn-default btn-cancel" @click="close()" :disabled="disableButtons">Отмена</button>
        <button class="btn-default btn-primary" @click="$emit('submit')" :disabled="disableButtons">
          <slot name="submit"></slot>
        </button>
      </div>
    </div>
  </div>
</template>
